export default "__VITE_ASSET__CmKw_liI__"